import React, { useRef, useState, useEffect } from "react";
import { motion } from "framer-motion";
import { photoUrl } from "../../config";
import PhotoMosaic from "../PhotoMosaic";
import { MapPin } from "lucide-react";

export default function HeroSection({
  hotelData,
  accentColor = "#14b8a6",
  onPhotoViewerOpen, // Функция для открытия просмотрщика фото
}) {
  const [guestsOpen, setGuestsOpen] = useState(false);
  const [showAgeDropdown, setShowAgeDropdown] = useState(false);
  const [hotelImages, setHotelImages] = useState([]);
  const guestsRef = useRef(null);
  const ageDropdownRef = useRef(null);

  // Формируем массив изображений из данных отеля
  useEffect(() => {
    console.log("hotelData", hotelData);
    if (hotelData?.photos?.length > 0 && hotelData?.photo_url) {
      const images = hotelData.photos.map((photo) => ({
        src: `${photoUrl}/${hotelData.photo_url}/hotel/${photo}.jpg`,
        name: photo,
        position: hotelData?.photos_positions?.[photo] || "",
      }));
      setHotelImages(images);
    }
  }, [hotelData]);

  useEffect(() => {
    const handler = (e) => {
      if (guestsRef.current && !guestsRef.current.contains(e.target))
        setGuestsOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  useEffect(() => {
    if (!showAgeDropdown) return;
    const handler = (e) => {
      if (ageDropdownRef.current && !ageDropdownRef.current.contains(e.target))
        setShowAgeDropdown(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [showAgeDropdown]);

  const handlePhotoClick = (index) => {
    if (onPhotoViewerOpen) {
      onPhotoViewerOpen(hotelImages, index);
    }
  };

  const galleryImages = hotelImages.map((img) => img.src);

  return (
    <section className="relative bg-white">
      {/* Branding header */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-5 sm:pt-7 pb-4 sm:pb-5">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4"
        >
          {/* Левая часть: логотип + название */}
          <div className="flex items-start gap-4 min-w-0">
            {/* Логотип/фото отеля */}
            {hotelData && hotelImages[0] && (
              <img
                src={galleryImages[0]}
                style={{
                  objectPosition: hotelImages[0]?.position || "",
                }}
                alt={hotelData?.name || ""}
                className="w-16 h-16 rounded-xl object-cover flex-shrink-0"
              />
            )}

            <div className="flex flex-col gap-1 min-w-0">
              {/* Бейдж с типом отеля */}
              {hotelData?.template && (
                <span
                  className="px-3 py-1.5 text-xs font-medium rounded-full self-start leading-none"
                  style={{
                    backgroundColor: `${accentColor}20`,
                    color: accentColor,
                    border: `1px solid ${accentColor}40`,
                  }}
                >
                  {hotelData.template}
                </span>
              )}

              {/* Название отеля */}
              <h1 className="text-gray-900 text-3xl font-bold leading-tight sm:text-4xl lg:text-5xl">
                {hotelData?.name || `#${hotelData?.id}`}
              </h1>

              {/* Аннотация */}
              {hotelData?.annotation && (
                <p className="text-gray-600 text-sm sm:text-base mt-2 max-w-2xl leading-relaxed">
                  {hotelData.annotation}
                </p>
              )}
            </div>
          </div>

          {/* Правая часть: адрес (на мобильных уходит вниз) */}
          <div className="flex flex-col gap-2 text-gray-600 text-sm sm:text-base sm:max-w-xs sm:flex-shrink-0 sm:pt-1">
            {hotelData?.address && (
              <div className="flex items-start gap-2">
                <MapPin
                  className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0 mt-0.5"
                  style={{ color: accentColor }}
                />
                <span className="leading-snug">{hotelData.address}</span>
              </div>
            )}
            <div className="sm:text-right">
              <a
                href={`https://gostim.ru/to_object/${hotelData._id}`}
                className="text-sm"
              >
                Вы владелец этой организации?
              </a>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Photo mosaic */}
      {galleryImages.length > 0 && (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-6 sm:pb-8">
          <PhotoMosaic images={galleryImages} onPhotoClick={handlePhotoClick} />
        </div>
      )}
    </section>
  );
}
